import type { HowItWorkItem } from '~/components/pages/directions/how-it-work-section/how-it-works.types'

const HOW_IT_WORK_DOSTUPSREDA: HowItWorkItem = {
    cards: [
        {
            id: 1,
            title: '1. Тифлокомментатор надевает микрофон',
            description:
                'Компактный головной микрофон подключен к&nbsp;мобильному передатчику',
            alt: 'Тифлокомментатор с микрофоном',
            width: 880,
            height: 488,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/woman-with-headphones-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/woman-with-headphones.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/woman-with-headphones-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/woman-with-headphones.webp',
        },
        {
            id: 2,
            title: '2. Работает один или в паре',
            description:
                'В&nbsp;кабине или отдельном помещении, комментирует происходящее или надиктовывает заготовленный текст',
            alt: 'Работу выполняет один или в паре',
            width: 880,
            height: 587,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/audio-to-interpreters.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/audio-to-interpreters-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/audio-to-interpreters.webp',
        },
        {
            id: 3,
            title: '3. Всё слышно',
            description:
                'Посетитель с&nbsp;нарушениями слуха или зрения, слышит голос через наушники или персональный слуховой аппарат при помощи индукционной петли',
            alt: 'Индукционная петля',
            width: 880,
            height: 488,
            filled_image:
                '/assets/images/ui/how-it-work/jpg-png/induction-loop-drawing.png',
            image: '/assets/images/ui/how-it-work/jpg-png/induction-loop.png',
            filled_image_webp:
                '/assets/images/ui/how-it-work/webp/induction-loop-drawing.webp',
            image_webp:
                '/assets/images/ui/how-it-work/webp/induction-loop.webp',
        },
    ],
    video: {
        title: 'А как в работе',
        name: 'Как используется',
        description:
            'Процесс реальной работы переводчиков в кабине с пультом SPBAUDIO',
        width: 400,
        height: 224,
        video_preview:
            '/assets/images/usage/sinhroperevod/jpg-png/sinhroperevod-in-translation-booth-2.jpg',
        video_preview_webp:
            '/assets/images/usage/sinhroperevod/webp/sinhroperevod-in-translation-booth-2.webp',
        duration: '0:44',
        link: 'f98f49d76702c8b344866ee545e929c8',
    },
}

export default HOW_IT_WORK_DOSTUPSREDA
